import { render, staticRenderFns } from "./AgeChioce.vue?vue&type=template&id=fbaed054&scoped=true"
import script from "./AgeChioce.vue?vue&type=script&lang=js"
export * from "./AgeChioce.vue?vue&type=script&lang=js"
import style0 from "./AgeChioce.vue?vue&type=style&index=0&id=fbaed054&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaed054",
  null
  
)

export default component.exports